import React, { forwardRef, ReactNode } from 'react'

import classNames from 'classnames'

interface Props {
  children?: ReactNode
  className?: string
}

const Breadcrumbs = forwardRef<HTMLOListElement, Props>(({ children, className }: Props, ref) => {
  const items = React.Children.toArray(children).map((child, index) => (
    <li
      className="p-1 rounded hover:bg-gray-highlight hover:bg-blend-multiply dark:hover:bg-gray-highlight-dm dark:hover:bg-blend-normal"
      key={`child-${index}`}>
      {child}
    </li>
  ))
  return (
    <ol ref={ref} className={classNames('text-md flex flex-row items-center', className)}>
      {insertSeparators(items)}
    </ol>
  )
})
export default Breadcrumbs

const BreadcrumbSeparator: React.FC = () => (
  <i className="nf-icon align-text-bottom nf-chevron-right text-gray-text px-1" />
)

function insertSeparators(items: JSX.Element[]): JSX.Element[] {
  return items.reduce<JSX.Element[]>((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, <BreadcrumbSeparator key={`separator-${index}`} />)
    } else {
      acc.push(current)
    }
    return acc
  }, [])
}
